import React, { useEffect } from "react";
import { useAppDispatch as useDispatch } from "src/core/redux/hooks";
import { setPageTitle } from "src/core/redux";
import { SentinelBasePage } from "../sentinel-base";
import {
  Box,
  Button,
  Container,
  Header,
  StatusIndicator,
} from "@cloudscape-design/components";
import { useParams, useNavigate } from "react-router-dom";

export const CRDashboardPage: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { teamName } = useParams<{ teamName: string }>();

  useEffect(() => {
    dispatch(setPageTitle("CR Dashboard"));
  }, []);

  return (
    <SentinelBasePage>
      <Container
        header={
          <Header
            variant="h2"
            actions={
              <Button variant="link" onClick={() => navigate("/team")}>
                ← Back to Onboarded Teams
              </Button>
            }
          >
            CR Dashboard — {teamName || "Unknown Team"}
          </Header>
        }
      >
        <Box textAlign="center" padding={{ vertical: "xl" }}>
          <StatusIndicator type="info">
            CR Dashboard is in development and will be available soon.
          </StatusIndicator>
        </Box>
      </Container>
    </SentinelBasePage>
  );
};
